import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Modal } from "antd";
import styles from "./ObservadorRestablirContrasenyaFormulari.module.css";
import { fetchRestablirContrasenya } from "../../actions/consultesServidor";
import { NotificacioExit } from "../Notification";
import { RETARD_MILISEGONS_APARICIO_SPINNER } from "../../constantsObservacions";
import {
  MISSATGE_RESTABLIR_CONTRASENYA_ERROR,
  MISSATGE_RESTABLIR_CONTRASENYA_OK
} from "../../constantsFormularis";
import { errorConsultaServidor } from "../../actions/error";

class ObservadorRestablirContrasenyaFormulari extends Component {
  constructor(props) {
    super(props);
    this.state = { modalVisible: false, peticioEnCurs: false };
    this.mostrarModal = this.mostrarModal.bind(this);
    this.amagarModal = this.amagarModal.bind(this);
    this.onClickOk = this.onClickOk.bind(this);
  }

  onClickOk() {
    this.setState({ ...this.state, peticioEnCurs: true });
    return fetchRestablirContrasenya(this.props.idObservador).then(
      () => {
        this.setState({ modalVisible: false, peticioEnCurs: false });
        NotificacioExit(MISSATGE_RESTABLIR_CONTRASENYA_OK);
      },
      error => {
        this.setState({ modalVisible: true, peticioEnCurs: false });
        this.props.errorConsultaServidor(
          error,
          error.titol ? error.titol : MISSATGE_RESTABLIR_CONTRASENYA_ERROR
        );
      }
    );
  }

  mostrarModal() {
    this.setState({ ...this.state, modalVisible: true });
  }

  amagarModal() {
    this.setState({ ...this.state, modalVisible: false });
  }

  render() {
    const { modalVisible, peticioEnCurs } = this.state;
    const loadingBotoOK = peticioEnCurs
      ? { delay: RETARD_MILISEGONS_APARICIO_SPINNER }
      : false;

    return (
      <div>
        <Button size="large" type="primary" onClick={this.mostrarModal}>
          Restablir contrasenya
        </Button>
        <Modal
          visible={modalVisible}
          title="Restablir contrasenya"
          closable={false}
          className={styles.restablirContrasenyaModal}
          footer={[
            <Button
              key="ok"
              type="primary"
              loading={loadingBotoOK}
              onClick={this.onClickOk}
            >
              OK
            </Button>,
            <Button
              key="cancel"
              disabled={peticioEnCurs}
              onClick={this.amagarModal}
            >
              Cancel·lar
            </Button>
          ]}
        >
          <p className={styles.restablirContrasenyaMsg}>
            {
              "La contrasenya actual de l'observador es substituirà pel seu codi postal."
            }
          </p>
          <p className={styles.restablirContrasenyaConfirm}>
            {"Voleu continuar?"}
          </p>
        </Modal>
      </div>
    );
  }
}

ObservadorRestablirContrasenyaFormulari.propTypes = {
  idObservador: PropTypes.number,
  errorConsultaServidor: PropTypes.func
};

const mapDispatchToProps = {
  errorConsultaServidor
};
const mapStateToProps = () => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ObservadorRestablirContrasenyaFormulari);
